import I18n from 'I18n';
import { Box } from 'foundations-components/transitional/components/Box';
import { Progress as FoundationsProgress } from 'foundations-components/transitional/components/Progress';
import PropTypes from 'prop-types';
import Message from './Message';
import Progress from './Progress';
import SkippedArticlesNotice from './SkippedArticlesNotice';
import WarningNotice from './WarningNotice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuccessfullyCompleted = ({
  alteredArticlesListLink,
  autoPublishEnabled,
  count: warningsCount,
  importedArticleCount,
  progress,
  skippedArticleCount,
  totalArticleCount
}) => {
  const showSkippedArticles = skippedArticleCount > 0;
  const showWarningNotice = warningsCount > 0 && alteredArticlesListLink;
  const langKey = 'importCompleted';
  return /*#__PURE__*/_jsx(Progress, {
    alignItems: "center",
    children: /*#__PURE__*/_jsxs(Box, {
      grow: 1,
      children: [/*#__PURE__*/_jsx(Message, {
        completed: true,
        importedArticleCount: importedArticleCount,
        messageLangKey: `${langKey}.${autoPublishEnabled ? 'publishedImportMessage' : 'draftImportMessage'}`,
        progress: progress,
        progressLangKey: `${langKey}.progressLabel`,
        totalArticleCount: totalArticleCount
      }), /*#__PURE__*/_jsx(FoundationsProgress, {
        "aria-label": I18n.text('knowledgeContentUI.importArticles.panel.importCompleted.progressLabel', {
          count: progress
        }),
        use: "success",
        value: progress,
        marginBlockEnd: "100"
      }), showSkippedArticles && /*#__PURE__*/_jsx(SkippedArticlesNotice, {
        count: skippedArticleCount
      }), showWarningNotice && /*#__PURE__*/_jsx(WarningNotice, {
        count: warningsCount,
        alteredArticlesListLink: alteredArticlesListLink
      })]
    })
  });
};
SuccessfullyCompleted.propTypes = {
  autoPublishEnabled: PropTypes.bool.isRequired,
  // @ts-expect-error there's no way to allow undefined but disallow null in prop-types
  alteredArticlesListLink: PropTypes.shape({
    url: PropTypes.string
  }),
  count: PropTypes.number.isRequired,
  importedArticleCount: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
  skippedArticleCount: PropTypes.number.isRequired,
  totalArticleCount: PropTypes.number.isRequired
};
export default SuccessfullyCompleted;